import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [shareStatus, setShareStatus] = useState({ claimed: false, used_episode: null, available: false });

  const fetchShare = useCallback(async () => {
    try {
      const { data } = await api.get("/share/status");
      setShareStatus(data);
    } catch { /* ignore */ }
  }, []);

  const fetchMe = useCallback(async () => {
    const token = localStorage.getItem("iwk_token");
    if (!token) { setLoading(false); return; }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      fetchShare();
    } catch {
      localStorage.removeItem("iwk_token");
    } finally { setLoading(false); }
  }, [fetchShare]);

  useEffect(() => { fetchMe(); }, [fetchMe]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("iwk_token", data.token);
    setUser(data.user);
    await fetchShare();
    return data.user;
  };

  const signup = async (name, email, password, subscribe = true) => {
    const { data } = await api.post("/auth/signup", { name, email, password, subscribe });
    localStorage.setItem("iwk_token", data.token);
    setUser(data.user);
    setShareStatus({ claimed: false, used_episode: null, available: false });
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("iwk_token");
    setUser(null);
    setShareStatus({ claimed: false, used_episode: null, available: false });
  };

  const claimShare = async () => {
    const { data } = await api.post("/share/claim");
    await fetchShare();
    return data;
  };

  const redeemShare = async (episode_number) => {
    const { data } = await api.post("/share/redeem", { episode_number });
    await fetchShare();
    return data;
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, signup, logout, refresh: fetchMe, shareStatus, claimShare, redeemShare, refreshShare: fetchShare }}>
      {children}
    </AuthCtx.Provider>
  );
};

export const useAuth = () => useContext(AuthCtx);
